

const rowData1 = [
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > pesach',
    listingText: 'Pesach',
    sources: [],
    requiresReview: 'D',
    origin: 1,
    searchableText: 'Pesach',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > pesach',
    listingText: 'matzah',
    sources: [],
    requiresReview: 'D',
    origin: 1,
    searchableText: 'matzah',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > pesach',
    listingText: 'four cups of wine',
    sources: [],
    requiresReview: 'D',
    origin: 1,
    searchableText: 'four cups of wine',
  },
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > sukkos',
    listingText: 'Sukkos',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'Sukkos',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > sukkos',
    listingText: 'sukkah',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'sukkah',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > sukkos',
    listingText: 'lulav',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'lulav',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > sukkos',
    listingText: 'esrog',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'esrog',
  },
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > chanukah',
    listingText: 'Chanukah',
    sources: [],
    requiresReview: 'D',
    origin: 3,
    searchableText: 'Chanukah',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > chanukah',
    listingText: 'menorah',
    sources: [],
    requiresReview: 'D',
    origin: 3,
    searchableText: 'menorah',
  },
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > rosh hashana',
    listingText: 'Rosh Hashana',
    sources: [],
    requiresReview: null,
    origin: 1,
    searchableText: 'Rosh Hashana',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > rosh hashana',
    listingText: 'shofar',
    sources: [],
    requiresReview: null,
    origin: 1,
    searchableText: 'shofar',
  },
];

const rowData2 = [
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > shavous',
    listingText: 'Shavous',
    sources: [],
    requiresReview: 'D',
    origin: 1,
    searchableText: 'Shavous',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > shavous',
    listingText: 'cheescake',
    sources: [],
    requiresReview: 'D',
    origin: 1,
    searchableText: 'cheescake',
  },
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > purim',
    listingText: 'Purim',
    sources: [],
    requiresReview: 'D',
    origin: 1,
    searchableText: 'Purim',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > purim',
    listingText: 'megillah',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'megillah',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > purim',
    listingText: 'matanos laevyonim',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'matanos laevyonim',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > purim',
    listingText: 'seudah',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'seudah',
  },
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > simchas torah',
    listingText: 'Simchas Torah',
    sources: [],
    requiresReview: null,
    origin: 2,
    searchableText: 'Simchas Torah',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > simchas torah',
    listingText: 'dancing',
    sources: [],
    requiresReview: 'D',
    origin: 3,
    searchableText: 'dancing',
  },
  {
    isCategory: true,
    parentCategoryBreadCrumb: 'yomtov > yom kippur',
    listingText: 'Yom Kippur',
    sources: [],
    requiresReview: 'D',
    origin: 3,
    searchableText: 'Yom Kippur',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > yom kippur',
    listingText: 'fasting',
    sources: [],
    requiresReview: null,
    origin: 1,
    searchableText: 'fasting',
  },
  {
    isCategory: false,
    parentCategoryBreadCrumb: 'yomtov > yom kippur',
    listingText: 'davening',
    sources: [],
    requiresReview: null,
    origin: 1,
    searchableText: 'davening',
  },
];
export const rowDataObject = {
  rowData1,
  rowData2
};



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/data/grid-data.ts